import { useState, useEffect } from 'react';
import axios from 'axios';
import { ChevronDown, MessageSquareQuote } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PERIODS = [{ days: 30, label: '30 giorni' }, { days: 90, label: '3 mesi' }, { days: 365, label: '12 mesi' }];

const TopicRow = ({ t, max }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-slate-100 last:border-0" data-testid={`chat-topic-${t.topic}`}>
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-4 py-3 text-left group" data-testid={`chat-topic-toggle-${t.topic}`}>
        <span className="w-56 shrink-0 text-sm text-slate-700">{t.label}</span>
        <span className="flex-1 h-2 bg-slate-100 rounded-full overflow-hidden">
          <span className="block h-full bg-[#283880] rounded-full transition-[width] duration-700" style={{ width: `${(t.count / max) * 100}%` }} />
        </span>
        <span className="w-10 text-right text-sm font-semibold text-[#283880]" data-testid={`chat-topic-count-${t.topic}`}>{t.count}</span>
        <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="pb-3 pl-4 space-y-2" data-testid={`chat-topic-examples-${t.topic}`}>
          {t.examples.map((ex, i) => (
            <p key={i} className="flex gap-2 text-xs text-slate-500 italic"><MessageSquareQuote className="w-3.5 h-3.5 shrink-0 text-[#C9A227]" />{ex}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export const ChatTopicsPanel = () => {
  const [days, setDays] = useState(90);
  const [topics, setTopics] = useState(null);

  useEffect(() => {
    setTopics(null);
    axios.get(`${API}/admin/chat-topics`, { params: { days }, headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then((r) => setTopics(r.data))
      .catch(() => setTopics([]));
  }, [days]);

  const max = Math.max(1, ...(topics || []).map((t) => t.count));
  return (
    <div className="bg-white rounded-xl p-6 shadow-sm mb-8" data-testid="chat-topics-panel">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-4">
        <div>
          <h3 className="font-semibold text-[#283880]">Di cosa chiedono i visitatori</h3>
          <p className="text-xs text-slate-500">Temi delle domande fatte all'assistente. Clicchi un tema per vedere esempi anonimi.</p>
        </div>
        <div className="flex gap-1 bg-slate-100 rounded-lg p-1">
          {PERIODS.map((p) => (
            <button key={p.days} onClick={() => setDays(p.days)} data-testid={`chat-topics-period-${p.days}`}
              className={`text-xs px-3 py-1.5 rounded-md transition-colors ${days === p.days ? 'bg-white text-[#283880] shadow-sm font-medium' : 'text-slate-500 hover:text-[#283880]'}`}>
              {p.label}
            </button>
          ))}
        </div>
      </div>
      {topics === null && <p className="text-sm text-slate-400 py-6">Caricamento…</p>}
      {topics && topics.length === 0 && <p className="text-sm text-slate-400 py-6" data-testid="chat-topics-empty">Nessuna domanda nel periodo selezionato.</p>}
      {topics && topics.map((t) => <TopicRow key={t.topic} t={t} max={max} />)}
    </div>
  );
};
